import type { ReactNode } from "react";

interface PageHeroProps {
  kicker: string;
  title: string;
  description: string;
  children?: ReactNode;
}

export default function PageHero({ kicker, title, description, children }: PageHeroProps) {
  return (
    <section className="relative w-full overflow-hidden border-b border-background-200 bg-background-100">
      <div className="pointer-events-none absolute -right-16 top-0 h-64 w-64 rounded-full bg-primary-100/70 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-10 bottom-0 h-48 w-48 rounded-full bg-accent-100/60 blur-3xl"></div>
      <div className="relative w-full px-4 py-10 md:px-8 md:py-14 lg:px-12">
        {children}
        <div className="mt-5 flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.28em] text-primary-600">
          <span className="h-[1px] w-6 bg-primary-400"></span>
          {kicker}
        </div>
        <h1 className="mt-4 max-w-4xl font-heading text-[26px] font-semibold leading-snug text-foreground-950 md:text-[38px]">
          {title}
        </h1>
        <p className="mt-4 max-w-3xl text-sm leading-7 text-foreground-600 md:text-[15px]">{description}</p>
      </div>
    </section>
  );
}